import {
    Button,
    PageHeader,
    IconButton,
    TextView
} from '@components/2-molecules';

import React, { FC } from 'react';

import {
    Card,
    Modal,
    Row,
    Spacer,
    Title,
    PDFViewer,
} from '@components/1-atoms';

import {
    AppTemplate
} from '@components/4-templates';

import ViewContact from '@components/3-organisms/ContactInput/ContactView';
import LineItemsView from '@components/3-organisms/LineItems/LineItemsView';

import { DocumentSummary } from '@components/3-organisms';

import { STATE } from '@lib/constants';
import _ from 'underscore';

import { ForwardedPageProps } from '@lib/constants';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import { useDocumentEstimate } from '@lib/hooks/useDocument';
import Resize from '@assets/icons/resize';
import Sandwich from '@assets/icons/sandwich';
import Pane from '@components/1-atoms/Pane';

import generateDocumentTemplateFromData from './documentTemplate';
import * as utils from './utils';
import { useBusinessCountryCurrency } from '@lib/hooks/useBusiness';


const DocumentView: FC<ForwardedPageProps> = ({ navigation, data = {}, theme, ...props }) => {

    const [estimate,] = useDocumentEstimate({ data: data, state: STATE.CANCEL });
    const [currency,] = useBusinessCountryCurrency();

    const [pdfUri, setPdfUri] = React.useState<null | string>();
    
    const [isModalVisible, setModalVisiblility] = React.useState(false);
    const _openPreviewModal = () => setModalVisiblility(true);
    const _closePreviewModal = () => setModalVisiblility(false);
    
    const documentDef = generateDocumentTemplateFromData(estimate?.data, currency?.data?.symbol);

    React.useEffect(() => {
        (async () => {
            // TODO: This line freezes the page
            const base64 = await utils.generatePdfDataURI(documentDef) as string;
            // 📓: The PDF data URI is used to display A4 letter format of the document
            setPdfUri(base64);
        })();
    }, [estimate?.data, currency?.data?.symbol]);

    const filename = `${estimate?.data?.name} | ${estimate?.data?.contact?.name}.pdf`;
    const _print = async () => utils.print(documentDef);
    const _share = async () => utils.share(documentDef, filename);


    return (
        <AppTemplate hooks={[estimate, currency]}>

            <Modal visible={isModalVisible} onClose={_closePreviewModal} >
                {pdfUri ? <PDFViewer uri={pdfUri} /> : null}
            </Modal>

            <PageHeader
                title={estimate?.data?.name}
                left={<IconButton icon={<Sandwich />} onPress={navigation?.toggleDrawer} />} />

            <Card title='Document Preview' icon={<Resize />} onAction={_openPreviewModal}>

                <Pane inset>
                    <Title large bold>HEADER</Title>
                    <TextView label={"Number"} defaultValue={estimate?.data?.name} />
                    <Spacer h={1} />
                    <Row>
                        <TextView date mini label={"Date"} defaultValue={estimate?.data?.createdAt} />
                        <TextView date mini label={"Due Date"} defaultValue={estimate?.data?.dueDate} />
                    </Row>
                    <Spacer h={2} />
                </Pane>

                <Pane inset >
                    <Title large bold>{'CONTACT'}</Title>
                    <ViewContact defaultValue={estimate?.data?.contact} />
                </Pane>
                <Spacer h={2} />

                <Pane inset >
                    <Title large bold>{'ITEM(S)'}</Title>
                    <LineItemsView
                        currency={currency?.data?.symbol}
                        data={estimate?.data?.lineItems}
                    />
                </Pane>
                <Spacer h={2} />

                <DocumentSummary
                    currency={currency?.data?.symbol}
                    data={estimate?.data}
                />
                <Spacer h={1} />

                <Row><Title large bold>{'NOTE TO CUSTOMER'}</Title></Row>
                <TextView
                    multiline
                    defaultValue={estimate?.data?.noteToReceiver} />
            </Card>
            <Spacer h={2} />

            <Button primary onPress={_openPreviewModal} >PREVIEW IN PDF FORMAT</Button>
            <Spacer h={1} />

            <Button primary onPress={_print} >PRINT</Button>
            <Spacer h={1} />

            <Button primary onPress={_share} >SHARE</Button>
            <Spacer h={2} />

        </AppTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(DocumentView);